// extracted by mini-css-extract-plugin
export var themeSwitch = "ThemeSwitch-module--themeSwitch--zHhYN";
export var checkboxContainer = "ThemeSwitch-module--checkboxContainer--KCNcO";
export var checkboxFake = "ThemeSwitch-module--checkboxFake--24K2D";
export var checkbox = "ThemeSwitch-module--checkbox--3kk18";
export var label = "ThemeSwitch-module--label--16W_p";